import {createFileRoute} from '@tanstack/react-router';
import {StatementListPage} from 'pages/statements/StatementListPage/StatementListPage';

export const Route = createFileRoute('/_protected/home/')({
  component: StatementListPage,
  staticData: {crumbKey: 'navigation.accounts'},
});
